import { Box, styled, useMediaQuery } from '@mui/material';
import { useTranslation } from 'react-i18next';
import {
  CardHeader,
  HoverPill,
  StyledIdScanCard,
  StyledTextPlaceholder,
} from 'public/components/id-submission/id-card-placeholders/id-scan-card-shared-style/id-scan-card-shared-style';
import { theme } from 'redesign/theme';
import { IdCardPlaceholderProps } from '../types';

const BAR_CODE_LINE_WIDTH = [4, 8, 2, 8, 4, 8, 2, 8, 4, 8];

export const RearIdScanCard = ({ onClick, image }: IdCardPlaceholderProps) => {
  const { t } = useTranslation('web-common');
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <StyledIdScanCard elevation={0} onClick={onClick} image={image || undefined}>
      {!image ? (
        <>
          <StyledTextPlaceholder width="100%" height="20px" />
          <CardHeader>
            <StyledCardChip />
            <TextPlaceholderContainer>
              <StyledTextPlaceholder width="60%" height="10px" />
              <StyledTextPlaceholder width="40%" height="5px" />
            </TextPlaceholderContainer>
          </CardHeader>
          <CardFooter>
            <BarCodeContainer>
              {BAR_CODE_LINE_WIDTH.map((width, index) => (
                <CardBarCodeLine key={index} width={width} />
              ))}
            </BarCodeContainer>
            <TextPlaceholderContainer>
              <StyledTextPlaceholder width="70%" height="5px" />
              <StyledTextPlaceholder width="40%" height="5px" />
            </TextPlaceholderContainer>
          </CardFooter>
        </>
      ) : null}
      <HoverPill className={isMobile ? 'hover-pill-mobile' : 'hover-pill'}>
        {t('id-submission.id-scan.front-side.hover-pill')}
      </HoverPill>
    </StyledIdScanCard>
  );
};

const StyledCardChip = styled(Box)(({ theme }) => ({
  width: 50,
  height: 50,
  borderRadius: theme.spacing(3),
  backgroundColor: theme.palette.lwBlack[10],
}));

const CardFooter = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  width: '100%',
  gap: theme.spacing(4),
  overflow: 'hidden',
  alignItems: 'flex-end',
}));

const BarCodeContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  width: '50%',
  gap: theme.spacing(2),
  overflow: 'hidden',
}));

const CardBarCodeLine = styled(Box)<{ width: number }>(({ width, theme }) => ({
  width,
  height: 30,
  backgroundColor: theme.palette.lwBlack[10],
}));

const TextPlaceholderContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
  flex: 1,
  alignItems: 'flex-end',
}));
